'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype['finally'] = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/promise/lib/finally.js
 ** module id = 498
 ** module chunks = 0
 **/